import axios from 'external/axios'
import {SentimentSatisfied} from 'external/material'
import uploadFileTypes from 'components/Uploads/redux/types'

export const setUploadFile = data => ({
  type: uploadFileTypes.SET_UPLOAD_FILE,
  payload: data,
})

export const setUploadProgress = (id, progress) => ({
  type: uploadFileTypes.SET_UPLOAD_PROGRESS,
  payload: {
    id,
    progress,
  },
})

export const successUploadFile = file => ({
  type: uploadFileTypes.SUCCESS_UPLOAD_FILE,
  payload: file.id,
})

export const failureUploadFile = id => ({
  type: uploadFileTypes.FAILURE_UPLOAD_FILE,
  payload: id,
})

export const uploadFile = files => dispatch => {
  if (files.length) {
    files.forEach(async (file) => {
      const formPayload = new FormData()
      formPayload.append('file', file.file)
      
      try {
        axios.defaults.withCredentials = true
        await axios({
          baseURL: file.server,
          url: `/${file.folder}/${file.file.name}`,          
          method: 'post',
          data: formPayload,
          cancelToken: file.cancelSource.token,                    
          onUploadProgress: progress => {
            const { loaded, total } = progress

            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(setUploadProgress(file.id, percentageProgress))
          },
        })
        dispatch(successUploadFile(file))
      } catch (error) {
        if (axios.isCancel(error)) {
          // cancelled by user
          dispatch(cancelUpload(file.id))
        } else {
          // regular connection error
          dispatch(failureUploadFile(file.id))
        }
      }
    })
  }
}

export const retryUpload = (id) => (dispatch, getState) => {
  dispatch({
    type: uploadFileTypes.RETRY_UPLOAD_FILE,
    payload: id,
  })

  const { fileProgress } = getState().UploadFile

  const reuploadFile = [fileProgress[id]]
  
  dispatch(uploadFile(reuploadFile))
}

export const deleteUpload = (id) => async (dispatch, getState) => {
  const { fileProgress } = getState().UploadFile;
  const file = fileProgress[id]
  const folderParts = file.folder.split('/')  
  file.deleted = true 
  
  axios.defaults.withCredentials = true
  /*
  await axios({
    baseURL: file.server,        
    url: `/${file.folder}/${file.file.name}`,  
    method: 'delete',
  }) */

  dispatch({
    type: uploadFileTypes.DELETE_UPLOAD_FILE,
    payload: id,
  })
}
export const cancelUpload = (id) => (dispatch, getState) => {
  const { fileProgress } = getState().UploadFile;
  fileProgress[id].deleted = true   
  dispatch({
    type: uploadFileTypes.DELETE_UPLOAD_FILE, 
    payload: id, 
  })
}

export const resetUploads = () => dispatch => {    
  dispatch({
    type: uploadFileTypes.RESET_UPLOADS
  })
}

export const loadUploads = (filesData) => (dispatch) => {      
  dispatch({
    type: 'LOAD_UPLOADS',
    payload: filesData 
  })
}
